(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mouthguard-upload-fields"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
  const colourInput = event.target.closest('input[name="properties[Base colour]"]');
  if (!colourInput) return;
  const fieldset = colourInput.closest('.mouthguard-colour');
  if (!fieldset) return;
  const otherField = fieldset.querySelector('[data-mouthguard-colour-other-field]');
  const otherInput = fieldset.querySelector('[data-mouthguard-colour-other-input]');
  const isOther = colourInput.value === 'Other';
  otherField.hidden = !isOther;
  otherInput.required = isOther;
  if (!isOther) otherInput.value = '';
});

document.querySelectorAll('[data-mg-preview-root]').forEach((root) => {
  if (root.dataset.mgPreviewReady === 'true') return;
  root.dataset.mgPreviewReady = 'true';

  const fieldset = root.closest('.mouthguard-upload');
  const layersEl = root.querySelector('[data-mg-preview-layers]');
  const emptyEl = root.querySelector('[data-mg-preview-empty]');
  const expandButton = root.querySelector('[data-mg-preview-expand]');
  const overlay = root.querySelector('.mouthguard-preview__overlay');
  const previewWindow = root.querySelector('.mouthguard-preview__window');
  const productInfo = root.closest('product-info') || document;
  const getColourInputs = () => [...productInfo.querySelectorAll('.mouthguard-colour input[name="properties[Base colour]"]')];
  const fileInputs = fieldset ? [...fieldset.querySelectorAll('[data-mg-preview-source]')] : [];
  const uploadIntro = fieldset ? fieldset.querySelector('[data-mg-upload-intro]') : null;
  const uploadTitle = fieldset ? fieldset.querySelector('[data-mg-upload-title]') : null;
  const uploadHint = fieldset ? fieldset.querySelector('[data-mg-upload-hint]') : null;
  const uploadTypes = fieldset ? fieldset.querySelector('[data-mg-upload-types]') : null;
  const uploadFields = fieldset ? [...fieldset.querySelectorAll('[data-mg-upload-field]')] : [];
  const notesField = fieldset ? fieldset.querySelector('[data-mg-notes-field]') : null;
  const notesLabel = fieldset ? fieldset.querySelector('[data-mg-notes-label]') : null;
  const notesInput = fieldset ? fieldset.querySelector('[data-mg-design-notes]') : null;
  const impressionStep = productInfo.querySelector('[data-mg-impression-step]');
  const impressionInputs = [...productInfo.querySelectorAll('[data-mg-impression]')];
  const impressionStatus = productInfo.querySelector('[data-mg-impression-status]');
  const nextList = productInfo.querySelector('[data-mg-next-list]');
  const reviewDesign = productInfo.querySelector('[data-mg-review-design]');
  const reviewImpression = productInfo.querySelector('[data-mg-review-impression]');
  const reviewColour = productInfo.querySelector('[data-mg-review-colour]');
  const reviewFilesRow = productInfo.querySelector('[data-mg-review-files-row]');
  const reviewFiles = productInfo.querySelector('[data-mg-review-files]');
  const reviewTotal = productInfo.querySelector('[data-mg-review-total]');
  const reviewPriceOptions = [...productInfo.querySelectorAll('[data-mg-review-price-option]')];
  const getVariantPicker = () => productInfo.querySelector('variant-selects[data-product-handle="mouthguard"]');
  const designSummary = productInfo.querySelector('[data-mg-design-summary]');

  const applySelectedBaseColour = (target) => {
    if (!target) return;
    target.classList.remove('is-clear', 'is-other');
    target.style.background = '#f7f7f7';
    target.style.backgroundImage = 'none';
    target.style.backgroundSize = '';
    target.style.backgroundPosition = '';

    const selected = getColourInputs().find((input) => input.checked);
    if (!selected) return;

    if (selected.value === 'Clear') {
      target.style.background = 'rgba(255,255,255,.55)';
      target.style.backgroundImage = 'linear-gradient(45deg, rgba(220,220,220,.55) 25%, transparent 25%), linear-gradient(-45deg, rgba(220,220,220,.55) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(220,220,220,.55) 75%), linear-gradient(-45deg, transparent 75%, rgba(220,220,220,.55) 75%)';
      target.style.backgroundSize = '18px 18px';
      target.style.backgroundPosition = '0 0, 0 9px, 9px -9px, -9px 0';
      return;
    }

    if (selected.value === 'Other') {
      target.style.background = '#f2f2f2';
      return;
    }

    const colour = selected.dataset.mgColourHex || '';
    if (colour) target.style.background = colour;
  };

  const states = Array.from({ length: 5 }, (_, index) => ({
    index,
    src: '',
    filename: '',
    objectUrl: '',
    zoom: 1,
    x: 0,
    y: 0,
    fit: 'contain',
    rotation: 0,
    flipX: 1
  }));
  let activeIndex = 0;

  const getDesignLevel = () => {
    if (fieldset && fieldset.dataset.mgFixedLevel) return fieldset.dataset.mgFixedLevel;
    const picker = getVariantPicker();
    if (!picker) return 'No design';

    const checked = picker.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value || 'No design';

    const selected = picker.querySelector('select option:checked');
    return selected ? selected.value : 'No design';
  };

  const maxUploadsForDesign = (designLevel) => {
    const value = String(designLevel || '').toLowerCase();
    if (value === 'simple design') return 2;
    if (value === 'custom design') return 3;
    if (value === 'full complex design') return 5;
    return 0;
  };

  const formatPosition = (value, negativeLabel, positiveLabel) => {
    if (Math.abs(value) < 1) return 'Centre';
    return Math.abs(value).toFixed(0) + '% ' + (value < 0 ? negativeLabel : positiveLabel);
  };

  const saveState = (state) => {
    const number = String(state.index + 1);
    const zoom = fieldset.querySelector('[data-mg-preview-zoom="' + number + '"]');
    const x = fieldset.querySelector('[data-mg-preview-x="' + number + '"]');
    const y = fieldset.querySelector('[data-mg-preview-y="' + number + '"]');
    const fit = fieldset.querySelector('[data-mg-preview-fit="' + number + '"]');
    const rotation = fieldset.querySelector('[data-mg-preview-rotation="' + number + '"]');
    const flip = fieldset.querySelector('[data-mg-preview-flip="' + number + '"]');
    if (zoom) zoom.value = Math.round(state.zoom * 100) + '%';
    if (x) x.value = formatPosition(state.x, 'left', 'right');
    if (y) y.value = formatPosition(state.y, 'up', 'down');
    if (fit) fit.value = state.fit === 'cover' ? 'Crop to fill' : 'Fit';
    if (rotation) rotation.value = state.rotation + '°';
    if (flip) flip.value = state.flipX === -1 ? 'Yes' : 'No';
  };

  const applyTransform = (image, state) => {
    image.style.objectFit = state.fit;
    image.style.transform = 'translate(' + state.x + '%, ' + state.y + '%) rotate(' + state.rotation + 'deg) scale(' + state.zoom + ') scaleX(' + state.flipX + ')';
  };

  const loadedStates = () => states.filter((state) => state.src);

  const getPriceForDesign = (designLevel, includeKit = false) => {
    const wanted = String(designLevel || '').trim().toLowerCase();
    const match = reviewPriceOptions.find((option) =>
      String(option.dataset.mgReviewPriceOption || '').trim().toLowerCase() === wanted
    );
    if (!match && fieldset && fieldset.dataset.mgFixedLevel && reviewPriceOptions.length === 1) {
      const option = reviewPriceOptions[0];
      return includeKit ? option.dataset.mgReviewPriceWithKit : option.dataset.mgReviewPriceValue;
    }
    if (!match) return '';
    return includeKit ? match.dataset.mgReviewPriceWithKit : match.dataset.mgReviewPriceValue;
  };

  const updateQuickReview = (designLevelOverride) => {
    const designLevel = designLevelOverride || getDesignLevel();
    const selectedColour = getColourInputs().find((input) => input.checked);
    const selectedImpression = impressionInputs.find((input) => input.checked);
    const needsKit = selectedImpression && selectedImpression.value === 'No';
    const hasDesign = maxUploadsForDesign(designLevel) > 0;
    const uploadedCount = fileInputs.filter((input) => input.files && input.files.length > 0).length;
    const price = getPriceForDesign(designLevel, needsKit);
    const sendKit = impressionStep ? impressionStep.querySelector('[data-mg-send-kit]') : null;
    if (sendKit) sendKit.value = !selectedImpression ? '' : (needsKit ? 'Yes — send included kit' : 'No — already have impression or kit');

    if (reviewDesign) reviewDesign.textContent = designLevel === 'No design' ? 'Basic' : (designLevel || 'Basic');
    if (reviewImpression) {
      if (!selectedImpression) {
        reviewImpression.textContent = 'Choose Yes or No';
      } else if (needsKit) {
        reviewImpression.textContent = 'No — send my included kit';
      } else {
        reviewImpression.textContent = 'Yes — no kit needed';
      }
    }
    if (impressionStatus) {
      impressionStatus.textContent = !selectedImpression
        ? ''
        : needsKit
          ? 'We’ll send your included Customs Kit. Your mouthguard price stays the same.'
          : 'Perfect — no kit needs to be sent. Your mouthguard price stays the same.';
    }
    if (reviewColour) reviewColour.textContent = selectedColour ? selectedColour.value : 'Choose a colour';
    if (reviewFilesRow) reviewFilesRow.hidden = !hasDesign;
    if (reviewFiles) reviewFiles.textContent = String(uploadedCount);
    if (reviewTotal) reviewTotal.textContent = price;
  };

  const updateDesignSummary = (designLevel) => {
    if (!designSummary) return;
    const label = String(designLevel || getDesignLevel() || '').trim();
    if (!label) {
      designSummary.textContent = '';
      designSummary.hidden = true;
      return;
    }

    const priceEl = productInfo.querySelector(
      '.price__container .price-item--sale, .price__container .price-item--regular, .price-item--regular'
    );
    const price = priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '';
    designSummary.textContent = price ? 'Selected: ' + label + ' — ' + price : 'Selected: ' + label;
    designSummary.hidden = false;
  };

  const renderInline = () => {
    applySelectedBaseColour(previewWindow);
    layersEl.innerHTML = '';
    states.forEach((state) => {
      if (!state.src) return;
      const image = document.createElement('img');
      image.className = 'mouthguard-preview__layer';
      image.src = state.src;
      image.alt = state.filename || ('Design file ' + (state.index + 1));
      applyTransform(image, state);
      layersEl.appendChild(image);
      saveState(state);
    });
    const hasImages = loadedStates().length > 0;
    emptyEl.hidden = hasImages;
    expandButton.disabled = !hasImages;
    expandButton.hidden = !hasImages;
  };

  const resetState = (state) => {
    state.zoom = 1;
    state.x = 0;
    state.y = 0;
    state.fit = 'contain';
    state.rotation = 0;
    state.flipX = 1;
    saveState(state);
  };

  const updateDesignLevelUI = (designLevelOverride) => {
    const designLevel = designLevelOverride || getDesignLevel();
    const maxUploads = maxUploadsForDesign(designLevel);
    const hasDesign = maxUploads > 0;
    const isSimple = String(designLevel).toLowerCase() === 'simple design';

    if (uploadIntro) uploadIntro.hidden = !hasDesign;
    if (uploadTitle) {
      uploadTitle.textContent = '4. Upload up to ' + maxUploads + ' file' + (maxUploads === 1 ? '' : 's');
    }
    if (uploadHint) {
      if (maxUploads === 2) {
        uploadHint.textContent = 'Upload up to 2 reference files for your simple design.';
      } else if (maxUploads === 3) {
        uploadHint.textContent = 'Upload up to 3 reference files for your custom design.';
      } else if (maxUploads === 5) {
        uploadHint.textContent = 'Upload up to 5 files for your full complex design.';
      }
    }
    if (uploadTypes) uploadTypes.hidden = !hasDesign;
    if (notesField) notesField.hidden = !hasDesign;

    if (notesLabel) {
      notesLabel.textContent = isSimple ? 'Text / design notes (optional)' : 'Design notes (optional)';
    }
    if (notesInput) {
      notesInput.placeholder = isSimple
        ? 'Add any wording, initials, number or simple placement notes.'
        : 'Tell me anything else about wording, colours, placement or the overall look.';
      notesInput.disabled = !hasDesign;
      if (!hasDesign) notesInput.value = '';
    }

    if (nextList) {
      nextList.innerHTML = hasDesign
        ? '<li><span>Place your order</span></li><li><span>I review your files</span></li><li><span>I create your mock-up</span></li><li><span>You approve it</span></li><li><span>I make your custom mouthguard</span></li>'
        : '<li><span>Place your order</span></li><li><span>I make your custom mouthguard</span></li><li><span>Your mouthguard is ready to go</span></li>';
    }

    uploadFields.forEach((wrapper) => {
      const number = Number(wrapper.dataset.mgUploadField || 0);
      const show = hasDesign && number <= maxUploads;
      wrapper.hidden = !show;

      const input = wrapper.querySelector('input[type="file"]');
      if (input) {
        input.disabled = !show;

        if (!show && input.files && input.files.length) {
          const state = states[number - 1];
          if (state && state.objectUrl) URL.revokeObjectURL(state.objectUrl);
          if (state) {
            state.objectUrl = '';
            state.src = '';
            state.filename = '';
            resetState(state);
          }
          input.value = '';
        }
      }
    });

    updateDesignSummary(designLevel);
    updateQuickReview(designLevel);
    window.setTimeout(() => {
      updateDesignSummary(getDesignLevel());
      updateQuickReview(getDesignLevel());
    }, 120);
    renderInline();
  };

  const openModal = () => {
    const loaded = loadedStates();
    if (!loaded.length) return;
    if (!states[activeIndex].src) activeIndex = loaded[loaded.length - 1].index;

    const modal = document.createElement('div');
    modal.className = 'mouthguard-preview-modal';
    modal.innerHTML = `
      <div class="mouthguard-preview-modal__card" role="dialog" aria-modal="true" aria-label="Mouthguard artwork preview">
        <div class="mouthguard-preview-modal__head">
          <div>
            <p class="mouthguard-preview-modal__title"><strong>Position your artwork</strong></p>
            <p class="mouthguard-preview-modal__note">Each uploaded image is its own layer. Choose the image you want to edit, then drag, zoom, crop, rotate or flip it. Your original files still come through untouched.</p>
          </div>
          <button type="button" class="mouthguard-preview-modal__close" aria-label="Close preview">×</button>
        </div>
        <div class="mouthguard-preview-modal__stage" data-mg-modal-stage>
          <div class="mouthguard-preview-modal__window">
            <div class="mouthguard-preview-modal__base" data-mg-modal-base></div>
            <div class="mouthguard-preview-modal__layers" data-mg-modal-layers></div>
          </div>
          <img class="mouthguard-preview-modal__overlay" src="${overlay.src}" alt="" aria-hidden="true">
        </div>
        <div class="mouthguard-preview-modal__controls">
          <label class="mouthguard-preview-layer-label">Edit image</label>
          <select class="mouthguard-preview-layer-select" data-mg-modal-layer></select>
          <span></span>
          <label>Zoom</label>
          <input type="range" min="50" max="300" step="1" data-mg-modal-zoom>
          <span class="mouthguard-preview-modal__zoom-value" data-mg-modal-zoom-value></span>
          <div class="mouthguard-preview-modal__actions">
            <button type="button" class="mouthguard-preview-modal__action" data-mg-modal-fit>Crop to fill</button>
            <button type="button" class="mouthguard-preview-modal__action" data-mg-modal-rotate>Rotate 90°</button>
            <button type="button" class="mouthguard-preview-modal__action" data-mg-modal-flip>Flip</button>
            <button type="button" class="mouthguard-preview-modal__reset" data-mg-modal-reset>Reset selected image</button>
          </div>
          <p class="mouthguard-preview-modal__help">Image 1 sits at the back. Images 2–5 layer on top in number order. Drag directly on the mouthguard to move the selected image.</p>
        </div>
      </div>
    `;

    const modalLayers = modal.querySelector('[data-mg-modal-layers]');
    const modalWindow = modal.querySelector('.mouthguard-preview-modal__window');
    const stage = modal.querySelector('[data-mg-modal-stage]');
    const select = modal.querySelector('[data-mg-modal-layer]');
    const zoom = modal.querySelector('[data-mg-modal-zoom]');
    const zoomValue = modal.querySelector('[data-mg-modal-zoom-value]');
    const fitButton = modal.querySelector('[data-mg-modal-fit]');
    const rotateButton = modal.querySelector('[data-mg-modal-rotate]');
    const flipButton = modal.querySelector('[data-mg-modal-flip]');
    const resetButton = modal.querySelector('[data-mg-modal-reset]');

    const renderModal = () => {
      modalLayers.innerHTML = '';
      states.forEach((state) => {
        if (!state.src) return;
        const image = document.createElement('img');
        image.className = 'mouthguard-preview-modal__layer';
        if (state.index === activeIndex) image.classList.add('mouthguard-preview-modal__active');
        image.src = state.src;
        image.alt = state.filename || ('Design file ' + (state.index + 1));
        applyTransform(image, state);
        modalLayers.appendChild(image);
      });
      const state = states[activeIndex];
      zoom.value = String(Math.round(state.zoom * 100));
      zoomValue.textContent = Math.round(state.zoom * 100) + '%';
      fitButton.textContent = state.fit === 'cover' ? 'Fit whole image' : 'Crop to fill';
      flipButton.textContent = state.flipX === -1 ? 'Unflip' : 'Flip';
    };

    const buildSelector = () => {
      select.innerHTML = '';
      loadedStates().forEach((state) => {
        const option = document.createElement('option');
        option.value = String(state.index);
        option.textContent = 'Image ' + (state.index + 1) + (state.filename ? ' — ' + state.filename : '');
        option.selected = state.index === activeIndex;
        select.appendChild(option);
      });
    };

    applySelectedBaseColour(modalWindow);
    buildSelector();
    renderModal();

    select.addEventListener('change', () => {
      activeIndex = Number(select.value);
      renderModal();
    });

    zoom.addEventListener('input', () => {
      const state = states[activeIndex];
      state.zoom = Number(zoom.value) / 100;
      saveState(state);
      renderModal();
      renderInline();
    });

    fitButton.addEventListener('click', () => {
      const state = states[activeIndex];
      state.fit = state.fit === 'cover' ? 'contain' : 'cover';
      saveState(state);
      renderModal();
      renderInline();
    });

    rotateButton.addEventListener('click', () => {
      const state = states[activeIndex];
      state.rotation = (state.rotation + 90) % 360;
      saveState(state);
      renderModal();
      renderInline();
    });

    flipButton.addEventListener('click', () => {
      const state = states[activeIndex];
      state.flipX *= -1;
      saveState(state);
      renderModal();
      renderInline();
    });

    resetButton.addEventListener('click', () => {
      resetState(states[activeIndex]);
      renderModal();
      renderInline();
    });

    let dragging = false;
    let startClientX = 0;
    let startClientY = 0;
    let startX = 0;
    let startY = 0;

    stage.addEventListener('pointerdown', (event) => {
      const state = states[activeIndex];
      if (!state || !state.src) return;
      dragging = true;
      stage.classList.add('is-dragging');
      stage.setPointerCapture(event.pointerId);
      startClientX = event.clientX;
      startClientY = event.clientY;
      startX = state.x;
      startY = state.y;
    });

    stage.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const state = states[activeIndex];
      const rect = stage.getBoundingClientRect();
      state.x = startX + ((event.clientX - startClientX) / rect.width) * 100;
      state.y = startY + ((event.clientY - startClientY) / rect.height) * 100;
      saveState(state);
      renderModal();
      renderInline();
    });

    const endDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      stage.classList.remove('is-dragging');
      if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
    };

    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);

    const close = () => {
      renderInline();
      modal.remove();
      document.body.style.overflow = '';
    };

    modal.querySelector('.mouthguard-preview-modal__close').addEventListener('click', close);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) close();
    });
    document.addEventListener('keydown', function escHandler(event) {
      if (event.key === 'Escape') {
        document.removeEventListener('keydown', escHandler);
        close();
      }
    });

    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
  };

  expandButton.addEventListener('click', openModal);

  productInfo.addEventListener('change', (event) => {
    const designControl = event.target.closest(
      'variant-selects[data-product-handle="mouthguard"] input[type="radio"], variant-selects[data-product-handle="mouthguard"] select'
    );

    if (designControl) {
      const selectedValue = designControl.matches('select')
        ? designControl.value
        : designControl.value;
      updateDesignLevelUI(selectedValue);
      requestAnimationFrame(() => updateDesignLevelUI(selectedValue));
    }

    const impressionInput = event.target.closest('[data-mg-impression]');
    if (impressionInput) updateQuickReview();

    const colourInput = event.target.closest('.mouthguard-colour input[name="properties[Base colour]"]');
    if (colourInput) {
      applySelectedBaseColour(previewWindow);
      updateQuickReview();
    }
  });

  fileInputs.forEach((input) => {
    input.addEventListener('change', () => {
      const index = Number(input.dataset.mgPreviewSource) - 1;
      const state = states[index];
      if (!state) return;

      if (state.objectUrl) {
        URL.revokeObjectURL(state.objectUrl);
        state.objectUrl = '';
      }

      state.src = '';
      state.filename = '';
      resetState(state);

      const file = input.files && input.files[0];
      if (file && file.type.startsWith('image/')) {
        state.objectUrl = URL.createObjectURL(file);
        state.src = state.objectUrl;
        state.filename = file.name || ('Design file ' + (index + 1));
        activeIndex = index;
      }

      renderInline();
      updateQuickReview();
    });
  });

  window.addEventListener('beforeunload', () => {
    states.forEach((state) => {
      if (state.objectUrl) URL.revokeObjectURL(state.objectUrl);
    });
  });

  updateDesignLevelUI();
  updateQuickReview();
});
  } catch(e) { console.error(e); }
})();

})();
